import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

export const useGlobalBarcodeScanner = (onBarcodeScanned) => {
  const barcodeBufferRef = useRef('');
  const lastKeyTimeRef = useRef(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleKeyPress = (event) => {
      // Ignore if user is typing in an input field
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
        return;
      }

      const currentTime = Date.now();
      const timeDiff = currentTime - lastKeyTimeRef.current;
      
      // If time between keystrokes is very short (< 100ms), it's likely a barcode scanner
      // Also accumulate if it's been less than 1 second since last keystroke
      if (timeDiff < 1000) {
        barcodeBufferRef.current += event.key;
        lastKeyTimeRef.current = currentTime;
        
        // Clear any existing timeout
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        
        // Set new timeout to process the barcode after scanner finishes
        timeoutRef.current = setTimeout(() => {
          const scannedCode = barcodeBufferRef.current.trim();
          
          // Only process if it looks like a valid barcode (has reasonable length and format)
          if (scannedCode.length >= 5 && (
            scannedCode.includes('LN-') || 
            scannedCode.includes('ln-') ||
            scannedCode.match(/^[A-Z]+-[0-9]+/) ||
            scannedCode.match(/^[0-9]+$/)
          )) {
            console.log('🔍 Global barcode scanned:', scannedCode);
            toast.success(`Barcode scanned: ${scannedCode}`);
            
            // Call the callback function with the scanned code
            if (onBarcodeScanned) {
              onBarcodeScanned(scannedCode.toUpperCase());
            }
          }
          
          // Reset buffer
          barcodeBufferRef.current = '';
        }, 200); // Wait 200ms after last keystroke
        
      } else {
        // Reset if too much time has passed (manual typing)
        barcodeBufferRef.current = '';
        lastKeyTimeRef.current = currentTime;
      }
    };

    // Add global event listener
    document.addEventListener('keypress', handleKeyPress);
    
    // Cleanup
    return () => {
      document.removeEventListener('keypress', handleKeyPress);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [onBarcodeScanned]);
};